/* eslint-disable react/jsx-one-expression-per-line */
import React, { ReactNode } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import dayjs from 'dayjs'
import { useLang } from '~/hooks/useLang'



interface AuditLogDetailsModalProps {
  readonly open: boolean
  readonly onClose: (event?: object, reason?: string) => void
  readonly selectedRow: any
  readonly fieldsToDisplay?: ReadonlyArray<{
    readonly label: string
    readonly value: string | number | null | ReactNode
    readonly size?: number
  }>
}

export default function AuditLogDetailsModal({
  open,
  onClose,
  selectedRow,
  fieldsToDisplay,
}: AuditLogDetailsModalProps) {
  const { translate } = useLang()

  // Campos padrão (para compatibilidade com o uso atual)
  const defaultFields = selectedRow
    ? [
        {
          label: translate('User'),
          value: selectedRow['user:representation_name'],
        },
        { label: translate('Consulted origin'), value: selectedRow.origin },
        {
          label: translate('action'),
          value: selectedRow.action
            ? translate(selectedRow.action)
            : selectedRow.action_display ?? '',
        },
        {
          label: translate('Performed at'),
          value: dayjs(selectedRow.created_at).format('DD/MM/YYYY HH:mm'),
        },
        ...(selectedRow.device
          ? [
              { label: translate('Device ID'), value: selectedRow.device.id },
              {
                label: translate('Device Name'),
                value: selectedRow.device.name,
              },
              { label: translate('Brand'), value: selectedRow.device.brand },
              { label: translate('Model'), value: selectedRow.device.model },
              { label: translate('IMEI'), value: selectedRow.device.imei },
            ]
          : []),
      ]
    : []

  // Use campos customizados se fornecidos, senão use os padrão
  const fields = fieldsToDisplay || defaultFields

  return (
    <Dialog
      fullWidth
      maxWidth={'md'}
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        {translate('Actions Performed')}
        <IconButton aria-label="close" onClick={() => onClose()}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingTop: 5 }}>
        {selectedRow && (
          <Grid container xs={12} display={'flex'} flexDirection={'row'}>
            {fields.map((field, index) => {
              return (
                <Grid key={index} item xs={field.size || 3} sx={{ pr: 1, pt: 2 }}>
                  <Typography variant="subtitle1" fontWeight={'bold'}>
                    {field.label}:
                  </Typography>
                  <Typography variant="subtitle2">
                    {field.value}
                  </Typography>
                </Grid>
              )
            })}
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  )
}
